import { toastr } from 'react-redux-toastr';
import QueryString from 'query-string';
import {
  generateCreateBoardingDraftEndpoint,
  generateDeleteBoardingDraftEndpoint,
  MOVEMENT_REASON_ENDPOINT,
} from '../../config/endpoints';
import {
  DEFAULT_DELETE_CONFIG,
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_MOVEMENT_REASONS,
  FLAG_BOARDING_DRAFT_ACTIVITY,
  GET_MOVEMENT_REASONS,
  LOAD_MOVEMENT_REASONS,
} from '../types';

const flagBoardingDraftActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_BOARDING_DRAFT_ACTIVITY,
    payload: flag,
  });

const postBoardingDraftByItineraryId =
  async ({ itineraryId, boardingDraft }) =>
  async (dispatch) => {
    try {
      dispatch(flagBoardingDraftActivity(true));
      const url = generateCreateBoardingDraftEndpoint(itineraryId);
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(boardingDraft),
      });
      await isErrorResponse(response, null, dispatch);
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagBoardingDraftActivity(false));
    }
  };

const deleteBoardingDraft =
  async ({ itineraryId, boardingDraft }) =>
  async (dispatch) => {
    try {
      dispatch(flagBoardingDraftActivity(true));
      const url = generateDeleteBoardingDraftEndpoint(itineraryId);
      const payload = {
        ...boardingDraft,
      };
      const response = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagBoardingDraftActivity(false));
    }
  };

const loadBoardingMotives = (loading) => (dispatch) => {
  dispatch({
    type: LOAD_MOVEMENT_REASONS,
    payload: loading,
  });
};

const getAllMovementReasons =
  ({ isBoarding, isLeaving }) =>
  async (dispatch) => {
    try {
      dispatch(loadBoardingMotives(true));

      const query = {};

      if (isBoarding) query.isBoarding = true;
      if (isLeaving) query.isLeaving = true;

      const url = `${MOVEMENT_REASON_ENDPOINT}?${QueryString.stringify(query)}`;
      const response = await fetch(url, {
        ...DEFAULT_GET_CONFIG,
      });
      await isErrorResponse(response, null, dispatch);
      const data = await response.json();
      dispatch({
        type: GET_MOVEMENT_REASONS,
        payload: data,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(loadBoardingMotives(false));
    }
  };

const clearMovementReasons = () => (dispatch) => {
  dispatch({
    type: CLEAR_MOVEMENT_REASONS,
  });
};

export {
  flagBoardingDraftActivity,
  postBoardingDraftByItineraryId,
  deleteBoardingDraft,
  getAllMovementReasons,
  clearMovementReasons,
};
